// @need-translate
import {requestContext} from '../../requestContext';
import {GLOBAL_FORMAT, KOREAN_FORMAT} from '../constants';
import {formatWithCommas} from './formatWithCommas';

export function getFormattedNumberWithSuffix(value: number): string {
  const locale = requestContext.requestInfo?.lang.deviceLang ?? 'ko';
  if (locale === 'ko') {
    if (value >= KOREAN_FORMAT.HUNDRED_MILLION_THRESHOLD) {
      return `${formatWithCommas(Math.round(value / KOREAN_FORMAT.HUNDRED_MILLION_DIVISOR) / 10)}억`;
    } else if (value >= KOREAN_FORMAT.TEN_THOUSAND_THRESHOLD) {
      return `${formatWithCommas(Math.round(value / KOREAN_FORMAT.TEN_THOUSAND_DIVISOR) / 10)}만`;
    }
  } else {
    if (value >= GLOBAL_FORMAT.MILLION_THRESHOLD) {
      return `${formatWithCommas(Math.round(value / GLOBAL_FORMAT.MILLION_DIVISOR) / 10)}M`;
    } else if (value >= GLOBAL_FORMAT.THOUSAND_THRESHOLD) {
      return `${formatWithCommas(Math.round(value / GLOBAL_FORMAT.THOUSAND_DIVISOR) / 10)}K`;
    }
  }
  return formatWithCommas(Math.round(value));
}
